module.exports = __webpack_public_path__ + "static/media/save.e3555793.svg";